export const formatLongDate = (iso: string): string =>
    new Date(iso).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });

export const formatTimeOfDay = (iso: string): string =>
    new Date(iso).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });

/** "today at 9:35 AM" for a time earlier today, otherwise "October 30, 2026 at 9:35 AM". */
export const formatUpdatedAt = (params: { iso: string; now: Date }): string => {
    const { iso, now } = params;
    const day = new Date(iso).toDateString() === now.toDateString() ? 'today' : formatLongDate(iso);
    return `${day} at ${formatTimeOfDay(iso)}`;
};
